import { styled } from 'styled-components';
export const CurrencyBlock = styled.div`
  display: flex;
  padding: 12px;
  align-items: center;
  align-self: stretch;
  border-bottom: 3px solid #131315;
  justify-content: space-between;
  cursor: pointer;
  @media (max-width: 768px) {
    height: 60px;
    border-bottom: 3px solid #131315;
  }
`;
